import { FormControl, FormHelperText, MenuItem, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { Field } from '../../types/generic';
import { getHelperText } from '../../utils/form';
import LabelledSelect from '../LabelledSelect';

interface EncodingSelectorProps {
	name: string;
	encodingOptions?: string[];
	disabled?: boolean;
	fieldData: Field;
	setSelectedEncoding: (e: SelectChangeEvent<string | number | boolean>) => void;
}

const EncodingSelector: React.FC<EncodingSelectorProps> = ({
	name,
	encodingOptions = ['ISO-8859-1', 'CP-1252', 'UTF-8'],
	disabled,
	fieldData,
	setSelectedEncoding,
}) => {
	const helperText = getHelperText(fieldData);

	return (
		<FormControl fullWidth variant="outlined" sx={{ margin: 0 }} disabled={disabled} data-testid="file-encoding-selector">
			<LabelledSelect
				selectLabel="File Encoding"
				testId="encoding-select"
				name={name}
				value={fieldData.value as string | number | boolean}
				onChange={setSelectedEncoding}
				required={fieldData.required}
				error={fieldData.error}
			>
				{encodingOptions.map((opt) => {
					return (
						<MenuItem key={`opt-${opt}`} value={opt} data-testid={`encoding-select-option-${opt}`}>
							{opt}
						</MenuItem>
					);
				})}
			</LabelledSelect>

			{helperText && (
				<FormHelperText error={fieldData.error} data-testid="encoding-helper-text">
					{helperText}
				</FormHelperText>
			)}
		</FormControl>
	);
};

export default EncodingSelector;
